export const BulkMessagingPrefixes = {
  Campaigns: 'bulk-messaging-campaigns',
  Draft: 'bulk-messaging-draft',
  EmailEditor: 'bulk-email-editor',
  EmailTab: 'bulk-email-tab',
  TextTab: 'bulk-text-tab',
  NewPage: 'bulk-new-page',
  AllLocationsAllotment: 'bulk-all-locations-allotments',
};
